/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../models/customer_limits';
import '../../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "RetrieveCustomerLimitsRequest": {
                    "fields": {}
                  },
                  "RetrieveCustomerLimitsResponse": {
                    "fields": {
                      "customerLimits": {
                        "type": ".squareup.sfs.external.models.CustomerLimits",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.RetrieveCustomerLimitsRequest && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.RetrieveCustomerLimitsResponse) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Response will be based on the currently authorized Multipass person.
 * --
 *
 * SOURCE RetrieveCustomerLimitsRequest @ squareup/sfs/external/services/customer/retrieve_customer_limits.proto at 11:1
 */
export const RetrieveCustomerLimitsRequest = $root.lookupType('squareup.sfs.external.service.RetrieveCustomerLimitsRequest');
fixType(RetrieveCustomerLimitsRequest);
Builder.createAndAttachToType(RetrieveCustomerLimitsRequest);
/**
 * SOURCE RetrieveCustomerLimitsResponse @ squareup/sfs/external/services/customer/retrieve_customer_limits.proto at 14:1
 */
export const RetrieveCustomerLimitsResponse = $root.lookupType('squareup.sfs.external.service.RetrieveCustomerLimitsResponse');
fixType(RetrieveCustomerLimitsResponse);
Builder.createAndAttachToType(RetrieveCustomerLimitsResponse);